export enum AwardHistoryRange {
    Lifetime = 0,
    Last6Months = 6,
    Last12Months = 12,
}

export const DEFAULT_AWARD_HISTORY_RANGE = AwardHistoryRange.Last6Months;

const rangeSet = new Set<unknown>(Object.values(AwardHistoryRange));

export const isAwardHistoryRange = (value: number): value is AwardHistoryRange => rangeSet.has(value);

export enum AwardBarKind {
    Awarded = "awarded",
    Empty = "empty",
    InProgress = "inProgress",
}

export interface AwardEntry {
    lensName: string;
    amountMilliUsd: number;
}

export interface AwardBar {
    kind: AwardBarKind;
    monthStart: string;
    amountMilliUsd: number;
    awards: AwardEntry[];
}

export enum TopPerformerLensStatus {
    Awarded = "AWARDED",
    DidNotQualify = "DID_NOT_QUALIFY",
    InWindow = "IN_WINDOW",
    UnderReview = "UNDER_REVIEW",
    Unknown = "UNKNOWN",
}

export interface TopPerformerLensRow {
    lens: {
        id: string;
        name: string;
        iconUrl: string;
        organizationId: string;
        lensAccountId: { lensSpaceId?: string | null } | null;
    };
    status: TopPerformerLensStatus;
    qualifiedPosters?: number | null;
    postersThreshold: number;
    award: { amountMilliUsd: number; awardedMonth: string; paidOn?: string | null } | null;
}
